import script from "./StatsWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatsWidget.vue?vue&type=script&setup=true&lang=ts"

import "./StatsWidget.vue?vue&type=style&index=0&id=7d5f4dac&lang=scss"

const __exports__ = script;

export default __exports__